export const SUBCATEGORIES_LOAD = 'SUBCATEGORIES_LOAD';
export const SUBCATEGORIES_LOADED = 'SUBCATEGORIES_LOADED';
export const SUBCATEGORIES_UNLOAD = 'SUBCATEGORIES_UNLOAD';
